module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by Anne-Marie Slaughter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/preface01#pre1"
    }
  }, [_vm._v("Preface to the Paperback Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocat"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_vm._v("1. Introduction: It’s Not (Always) Your Fault")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" I: Prove-It-Again!")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Spotting Prove-It-Again! Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Prove-It-Again! Action Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" II: The Tightrope")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Spotting Tightrope Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Tightrope Action Plan: Neither a Bitch . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Tightrope Action Plan: . . . Nor a Bimbo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" III: The Maternal Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Spotting Maternal Wall Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Maternal Wall Action Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" IV: The Tug of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Spotting Tug of War Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Tug of War Action Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05#part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" V: Double Jeopardy?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Experience of Gender Bias Differs by Race")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06#part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" VI: Leave or Stay?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Leave or Stay? Reading the Tea Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Leave or Stay? Don’t Dismay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07#part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART")]), _vm._v(" VII: 20 Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Science of Savvy in 20 Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Conclusion: Jump-Starting the Stalled Gender Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#sel",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author#abo",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0